exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".terms{display:flex;align-items:center;justify-content:center}.terms .info{font-family:Graphik-Regular;width:350px;overflow-y:scroll;padding-top:25px;padding-bottom:25px;text-align:justify}.terms .info::-webkit-scrollbar{display:none}.terms .info h2{font-size:21px;margin:20px 0}.terms .info p{font-size:15px}.terms .info ul{margin:10px 18px}.terms.geo .info{font-family:Georgian-Regular}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/policies/terms/terms.scss
// module id = 935
// module chunks = 0